import { render, staticRenderFns } from "./ContactNotes.vue?vue&type=template&id=4785b548&"
import script from "./ContactNotes.vue?vue&type=script&lang=js&"
export * from "./ContactNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports